import { render, staticRenderFns } from "./DetailsSectionCourses.vue?vue&type=template&id=23988e79&scoped=true&"
import script from "./DetailsSectionCourses.vue?vue&type=script&lang=js&"
export * from "./DetailsSectionCourses.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSectionCourses.vue?vue&type=style&index=0&id=23988e79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23988e79",
  null
  
)

export default component.exports